import React from 'react';
import FlexBox from '@components/layout/FlexBox';

import { TransformAttributesEnhancement } from "@dndModels";

import TransformAttributesInput from '@dndComponents/creature/TransformAttributesInput';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  attributes: TransformAttributesEnhancement;
  disabled: boolean;
  use_creature: boolean;
  onChange: () => void;
}

export default function TransformAttributesEnhancementInput({
  attributes,
  disabled,
  use_creature,
  onChange
}: Props) {
  return (
    <FlexBox direction="column">
      <FlexBox xs_expand={0}>
        <EnhancementModeBox
          name="Attributes Mode"
          modes={["Leave","Replace","Add"]}
          value={attributes.mode}
          disabled={disabled}
          onChange={(changed) => {
            attributes.mode = changed as TransformAttributesEnhancement["mode"];
            onChange();
          }}
        />
      </FlexBox>
      { attributes.mode === "Add" &&
        <FlexBox xs_expand={0}>
          These are added to the Transform&apos;s attributes, replacing any of the Transform&apos;s that are for the same attribute.
        </FlexBox>
      }
      <FlexBox>
        <TransformAttributesInput
          attributes={attributes.value}
          disabled={disabled || attributes.mode === "Leave"}
          use_creature={use_creature}
          onChange={onChange}
        />
      </FlexBox>
    </FlexBox>
  );
}
